import {
	GET_PERMISSION_GROUPS_SUCCESS,
	GET_PERMISSION_GROUPS_FAILURE,
	GET_DEFAULT_MATTER_PERMISSIONS_REQUEST,
	GET_DEFAULT_MATTER_PERMISSIONS_SUCCESS,
	GET_DEFAULT_MATTER_PERMISSIONS_FAILURE,
	UPDATE_DEFAULT_MATTER_PERMISSIONS_REQUEST,
} from "../actions/types";

const initialState = {
	permissionGroups: [],
	// the last refresh was rate limited, so permissionGroups may be out of date
	permissionGroupsStale: false,
	users: [],
	usersBySub: {},
	editGroupDetails: {},
	newEditPermissionsLoading: true,
	newEditPermissionsLoadingV2: true,
	userRights: {},
	defaultMatterPermissions: {
		matterPermissionGlobalSetting: "allUsers",
		userAllowList: [],
		groupAllowList: [],
		allowSelfAddToMatter: false,
	},
	defaultMatterPermissionsLoading: true,
	availableUsers: [],
	availableGroups: [],
};

export default function (state = initialState, action) {
	var usersBySub = {};
	if (action?.payload?.users) {
		action.payload.users.forEach((u) => {
			usersBySub[u.sub] = { ...u };
		});
	} else {
		usersBySub = { ...state.usersBySub };
	}
	switch (action.type) {
		case GET_PERMISSION_GROUPS_SUCCESS:
			return {
				...state,
				newEditPermissionsLoading: false,
				permissionGroups: action.payload.availableGroups.map((g) => {
					return {
						...g,
						members: action.payload.groupMembership
							.filter((gm) => gm.groupID === g.id)
							.map((gm) => ({
								...gm,
								sub: gm.userSub,
								displayName: usersBySub[gm.userSub].displayName,
							})),
					};
				}),
				users: action.payload.users,
				usersBySub,
				permissionGroupsStale: false,
			};
		case GET_PERMISSION_GROUPS_FAILURE:
			return {
				...state,
				permissionGroupsStale: !!action.payload?.rateLimited,
			};
		case "GET_PERMISSION_GROUP_SUCCESS":
			return {
				...state,
				newEditPermissionsLoadingV2: false,
				users: action.payload.users,
				usersBySub,
				editGroupDetails: {
					group: action.payload.group,
					groupMembers: action.payload.groupMembers,
					groupPermissionFeatures:
						action.payload.groupPermissionFeatures,
				},
			};
		case "UNMOUNT_EDIT_PERMISSION_GROUP":
			return {
				...state,
				newEditPermissionsLoadingV2: true,
				editGroupDetails: {},
			};
		case "GET_RIGHTS_FOR_USER_SUCCESS":
			return {
				...state,
				userRights: action.payload.userRights,
			};
		case GET_DEFAULT_MATTER_PERMISSIONS_REQUEST:
			return {
				...state,
				defaultMatterPermissionsLoading: true,
			};
		case GET_DEFAULT_MATTER_PERMISSIONS_SUCCESS:
			return {
				...state,
				defaultMatterPermissions: {
					matterPermissionGlobalSetting:
						action.payload.matterPermissionGlobalSetting,
					userAllowList: action.payload.userAllowList,
					groupAllowList: action.payload.groupAllowList,
					allowSelfAddToMatter:
						action.payload.allowSelfAddToMatter || false,
				},
				availableUsers: action.payload.availableUsers,
				availableGroups: action.payload.availableGroups,
				defaultMatterPermissionsLoading: false,
			};
		case GET_DEFAULT_MATTER_PERMISSIONS_FAILURE:
			return {
				...state,
				defaultMatterPermissionsLoading: false,
			};
		case UPDATE_DEFAULT_MATTER_PERMISSIONS_REQUEST:
			return {
				...state,
				defaultMatterPermissionsLoading: true,
			};
		default:
			return state;
	}
}
